'use strict'

angular
  .module('basalteApp')
  .constant('BAS_STREAMING', {
    T_ID_DEEZER: 'deezer',
    T_ID_TIDAL: 'tidal',
    T_ID_SPOTIFY: 'spotify',
    K_ID_BO_DEEZER: 'bo:deezer',
    K_ID_BO_TIDAL: 'bo:tidal',
    EVT_STREAMING_SERVICES_UPDATED: 'evtStreamingServicesUpdated'
  })
